import React from 'react';
import { NavLink } from 'react-router-dom';
import type { BreadCrumb as BreadCrumbType } from './BreadCrumbs';

type Props = {
  breadCrumb: BreadCrumbType;
  isFinal: boolean;
};

const BreadCrumbWrapper = ({ url, isFinal, children }) => {
  if (isFinal || !url) {
    return <span>{children}</span>;
  }

  return <NavLink to={url}>{children}</NavLink>;
};

export const BreadCrumb = (props: Props) => {
  const { breadCrumb, isFinal } = props;

  if (breadCrumb.node) {
    return <li>{breadCrumb.node}</li>;
  }

  return (
    <li>
      <BreadCrumbWrapper url={breadCrumb.url} isFinal={isFinal}>
        {breadCrumb.text}
      </BreadCrumbWrapper>
    </li>
  );
};
